import { MutableRefObject, ReactElement, useRef } from 'react';
import { useClickAway } from 'react-use';
import { createPortal } from 'react-dom';
import { makeStyles } from '@material-ui/styles';
import { CloseFill, IconButton, Theme } from '@bizzabo/design-system';
import cn from 'clsx';

type Props = {
    children: ReactElement[];
    parentElementRef: MutableRefObject<HTMLElement>;
    onClose: () => void;
};

const ChatMessageDialog: React.FC<Props> = ({ children, parentElementRef, onClose }) => {
    const classes = useStyles();

    const dialogRef = useRef<HTMLDivElement>(null);
    useClickAway(dialogRef, onClose);

    return createPortal(
        <>
            <div className={cn(classes.modalShadow, 'chat-message-dialog')} />
            <div className={classes.container} ref={dialogRef}>
                <IconButton className={classes.closeIcon} onClick={onClose} icon={CloseFill} />
                {children}
            </div>
        </>,
        parentElementRef.current
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        modalShadow: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            background: theme.palette.greys['700'],
            opacity: 0.4,
            'z-index': 0,
            borderRadius: 33,
        },
        container: {
            display: 'flex',
            'flex-direction': 'column',
            'align-items': 'flex-start',
            padding: 20,

            background: theme.palette.greys['100'],
            'border-radius': 16,

            position: 'absolute',
            top: '25%',

            left: '50%',
            transform: 'translateX(-50%)',

            width: '90%',
            zIndex: 1,
        },
        closeIcon: {
            position: 'absolute',
            right: 25,
            top: 25,
            height: 16,
            width: 16,
            color: theme.palette.greys['400'],
            background: 'none',
        },
    }),
    { classNamePrefix: ChatMessageDialog.name }
);

export default ChatMessageDialog;
